import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

interface Option {
  key: string;
  value: string;
  icon: string;
}

@Component({
  selector: 'app-status-select',
  templateUrl: './status-select.component.html',
  styleUrls: ['./status-select.component.scss'],
})
export class StatusSelectComponent {
  @Output() formChange = new EventEmitter<FormControl>();
  @Input() form!: FormControl;
  @Input() isActive: boolean[] = [true, true]; // 0 is read, 1 is write

  options: Option[];

  constructor() {
    this.options = [
      { key: 'plan', value: '計画', icon: 'check' },
      { key: 'implementation', value: '実施', icon: 'check' },
      { key: 'cancel', value: '中止', icon: 'exclamation' },
    ];
  }

  get selected(): Option {
    return (
      this.options.find((item) => item.value === this.form.value) ??
      this.options[0]
    );
  }

  onChange(): void {
    this.formChange.emit(this.form);
  }
}
